import { IconArrowRight16, IconCalculator24, IconCharter24, IconPlaneTicket24 } from '@warp-ds/icons/react';
import { t } from 'shared/locale/texts';

import { trackOpenVerticalClick } from '@/util/tracking/otherVerticalsNav';

import styles from './OtherVerticalsNav.module.css';

const OtherVerticalsLinkContent = [
    { vertical: 'prepackage', path: '/reise/pakkereiser/resultat/', icon: <IconCharter24 aria-hidden /> },
    { vertical: 'last_minute', path: '/reise/restplasser/', icon: <IconPlaneTicket24 aria-hidden /> },
    { vertical: 'currency', path: '/reise/valuta/', icon: <IconCalculator24 aria-hidden /> },
];

export const OtherVerticalsNav = () => (
    <nav className={styles['other-verticals-nav']}>
        <h2 className="sr-only">{t('verticals.title')}</h2>
        <ul className={styles['other-verticals-nav__list']}>
            {OtherVerticalsLinkContent.map(({ vertical, path, icon }) => (
                <li className={styles['other-verticals-nav__list-item']} key={vertical}>
                    <a className={styles['other-verticals-nav__link']} href={path} onClick={() => trackOpenVerticalClick(vertical, path)}>
                        <div className={styles['other-verticals-nav__link-header']}>
                            <div className={styles['other-verticals-nav__link-title']}>
                                {icon}
                                {t(`verticals.${vertical}`)}
                            </div>
                            <IconArrowRight16 />
                        </div>
                        <span className={styles['other-verticals-nav__link-sub-title']}>{t(`verticals.${vertical}_sub`)}</span>
                    </a>
                </li>
            ))}
        </ul>
    </nav>
);
